import type { SheetColumn } from "../lib/sheetModel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { formatCourtTagLabel } from "@bw/shared/utils";

/**
 * Sticky court column header (court name + first tag). One per visible column.
 * The court name is the column's accessible anchor — the cell labels reference
 * it, and the test locates columns by this text.
 */
export function SheetCourtHead({ column }: { column: SheetColumn }) {
  return (
    <Stack
      role="columnheader"
      spacing={0}
      sx={{ minWidth: 64, px: 0.5, py: 0.75, alignItems: "center", textAlign: "center" }}
    >
      <Typography noWrap sx={{ fontWeight: 700, fontSize: "0.75rem", maxWidth: "100%" }}>{column.name}</Typography>
      {column.tag ? (
        <Typography noWrap variant="caption" color="text.secondary" sx={{ fontSize: "0.625rem", maxWidth: "100%", textTransform: "capitalize" }}>
          {formatCourtTagLabel(column.tag).replace(/_/g, " ")}
        </Typography>
      ) : null}
    </Stack>
  );
}
